import ApiHelper from "./ApiHelper";

class DashboardServices {
  static async getActiveRoles(str) {
    return ApiHelper.getAuthenticated(
      `dashboard/jobs?${str}`
    );
  }

  static async getRevenueOverview() {
    return ApiHelper.getAuthenticated(
      `dashboard/revenue`
    );
  }

  static async getUsersOverview() {
    return ApiHelper.getAuthenticated("dashboard/user");
  }

  static async getCandidatesOverview() {
    return ApiHelper.getAuthenticated("dashboard/professional");
  }
}
export default DashboardServices;
